import { Alert, Card, Empty, Row, Typography } from "antd";
import { postData } from "apiServices/common";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import LineData from "./LineData";

const ProductionTracker = ({ line_id, date, currentSlide, slideId }) => {
  const [searchParams] = useSearchParams();
  const effectiveDate = date || searchParams?.get("date");
  const [productionTrackerData, setProductionTrackerData] = useState({});

  function transformChartData(chart_data) {
    const result = [];

    chart_data.forEach((item) => {
      // Plan Quantity
      result.push({
        hour: item.hour,
        value: item.plan_qty,
        type: "Plan Quantity",
      });

      // Actual Quantity
      result.push({
        hour: item.hour,
        value: item.actual_qty,
        type: "Actual Quantity",
      });
    });

    // console.log(result);

    return result;
  }

  const initialGetData = useCallback(async () => {
    const payload = {
      line_id: line_id,
      ...(effectiveDate ? { date: effectiveDate } : {}),
    };
    const response = await postData(
      "/api/digitalization/bigscreen-dashboard/production-tracker",
      payload,
    );

    if (response && response?.code === 200) {
      const data = response?.data;

      setProductionTrackerData(data);
    }
  }, [line_id, effectiveDate]);

  useEffect(() => {
    if (line_id && currentSlide === slideId) {
      initialGetData();
    }
  }, [line_id, currentSlide, slideId, initialGetData]);

  return (
    <Card
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <Typography.Title level={3}>Production Tracker</Typography.Title>
      {productionTrackerData && productionTrackerData?.length > 0 ? (
        <Row gutter={24}>
          {productionTrackerData?.map((p) => (
            <LineData key={p?.id} data={transformChartData(p?.chart_data)} />
          ))}
        </Row>
      ) : (
        <Empty
          style={{
            width: "33%",
            margin: "auto",
            marginTop: "10%",
            marginBottom: "10%",
            height: "100%",
          }}
          description={
            <Alert
              message="No Data Found with selected line-id in Production Tracker"
              type="warning"
            />
          }
        />
      )}
    </Card>
  );
};

export default ProductionTracker;
